// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilBlack":"#2c2e2f","floatLabel":"style_floatLabel__3lDsP","activeText":"style_activeText__1r1NQ","error":"style_error__1FAsO"};